import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=86fdb31a&scoped=true"
import script from "./DetailProduct.vue?vue&type=script&lang=js"
export * from "./DetailProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fdb31a",
  null
  
)

export default component.exports